import { getIsAQuoteTemplate } from 'Cube/domain/postActionStages/utils/getIsQuoteATemplate'
import {
  CubeReducerState,
  DisabledReasonType,
  VisibleEnabledFeatureAvailable
} from 'modules/Cube/domain/cube.domain.types'
import { getEditQuoteAvailable } from './getEditQuoteAvailable'

export const getEditAmendmentEffectiveFromAvailable = (
  prevState: CubeReducerState
): VisibleEnabledFeatureAvailable => {
  if (getIsAQuoteTemplate(prevState)) {
    return {
      available: {
        visible: false,
        enabled: false
      },
      reasons: [
        {
          reasonType: DisabledReasonType.InvalidStatus,
          metadata: { status: prevState.data.common.status }
        }
      ]
    }
  }

  if (prevState.data.quote.dealType === 'AMENDMENT') {
    return getEditQuoteAvailable(prevState)
  }

  return {
    available: {
      visible: false,
      enabled: false
    },
    reasons: [
      {
        reasonType: DisabledReasonType.InvalidDealType,
        metadata: {}
      }
    ]
  }
}
